module.exports = __webpack_public_path__ + "img/rongyu-08.4994092a.png";